var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.showInput
      ? _c("div", { staticClass: "people_box" }, [
          _vm.showRenNumber ? _c("b", [_vm._v("人数")]) : _vm._e(),
          _c(
            "p",
            [
              _c("b", [_vm._v("亲，客人共  ")]),
              _c("el-input-number", {
                staticStyle: { width: "1.2rem" },
                attrs: { size: "mini", min: 0, label: "成人" },
                model: {
                  value: _vm.spotData.adult,
                  callback: function ($$v) {
                    _vm.$set(_vm.spotData, "adult", $$v)
                  },
                  expression: "spotData.adult",
                },
              }),
              _vm._v("   成人   "),
              _c("el-input-number", {
                staticStyle: { width: "1.2rem" },
                attrs: { size: "mini", min: 0, label: "儿童" },
                model: {
                  value: _vm.spotData.children,
                  callback: function ($$v) {
                    _vm.$set(_vm.spotData, "children", $$v)
                  },
                  expression: "spotData.children",
                },
              }),
              _vm._v("   儿童   "),
            ],
            1
          ),
        ])
      : _c("div"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }